var ns;
ns.App.factory('ApiExportStatusMsgFactory', function(API_EXPORT_MSG){
  return {
    createMsg:function($statusCode){
      return API_EXPORT_MSG[$statusCode];
    }
  };
});
